"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var Subject_1 = require("rxjs/Subject");
var Observable_1 = require("rxjs/Observable");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_document_service_client_js_1 = require("@synisys/idm-document-service-client-js");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var selection_mode_model_1 = require("./models/selection-mode.model");
var document_manager_service_1 = require("./document-manager-service");
var url_and_query_params_1 = require("../../../shared/utils/url-and-query-params");
var notification_dialog_component_1 = require("./dialog/notification.dialog.component");
var document_merge_component_1 = require("../document-merge-dialog/document-merge.component");
var form_resolution_service_1 = require("../../../shared/services/api/form-resolution.service");
var document_history_service_1 = require("../document-history/service/document.history.service");
var document_manager_config_provider_1 = require("./service/api/document-manager-config.provider");
var data_for_merging_1 = require("../document-merge-dialog/model/data-for-merging");
var dynamic_navigation_helper_1 = require("../../summary-pages/common/utils/dynamic-navigation-helper");
var document_manager_filter_criteria_model_1 = require("./models/document-manager-filter-criteria.model");
var document_operations_service_1 = require("../../../shared/services/api/document-operations.service");
var entity_name_provider_service_1 = require("../../../shared/services/api/entity-name-provider.service");
var meta_knowledge_provider_service_1 = require("../../../shared/services/api/meta-knowledge-provider.service");
var documents_export_dialog_component_1 = require("../documents-export-dialog/documents-export-dialog.component");
var static_method_1 = require("../../../shared/utils/static-method");
var document_history_dialog_component_1 = require("../document-history/component/document-history-dialog/document-history-dialog.component");
var DocumentManagerComponent = /** @class */ (function () {
    function DocumentManagerComponent(documentService, documentOperationsService, http, deService, currentLanguageProvider, documentManagerService, route, dialog, entityNameProviderService, formResolutionService, sessionDataProvider, authorizationService, kbService, metaKnowledgeProviderService, documentManagerConfigProvider, injector) {
        this.documentService = documentService;
        this.documentOperationsService = documentOperationsService;
        this.http = http;
        this.deService = deService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.documentManagerService = documentManagerService;
        this.route = route;
        this.dialog = dialog;
        this.entityNameProviderService = entityNameProviderService;
        this.formResolutionService = formResolutionService;
        this.sessionDataProvider = sessionDataProvider;
        this.authorizationService = authorizationService;
        this.kbService = kbService;
        this.metaKnowledgeProviderService = metaKnowledgeProviderService;
        this.documentManagerConfigProvider = documentManagerConfigProvider;
        this.injector = injector;
        this.allDocumentsLabel = 'All';
        this.hasCheckBoxes = false;
        this.isDocumentDataInitialized = false;
        this.searchIsOpen = false;
        this.selectedFolder = this.allDocumentsLabel;
        this.selectedDocuments = [];
        this.displayedColumns = ['checkbox', 'title', 'folder', 'documentTypeId', 'uploadedOn', 'uploadedBy', 'actions'];
        this.documentFilterCriteria = new document_manager_filter_criteria_model_1.DocumentManagerFilterCriteriaModel(null, null, null, null);
        this.dataSource = new material_1.MatTableDataSource([]);
        this.pageLimit = 10;
        this.pageTotalCount = 0;
        this.totalItemsCount = 0;
        this.allDocumentsCount = 0;
        this.reloading = false;
        this.isEverySelected = false;
        this.isSomeSelected = false;
        this.isItemSelected = {};
        this.isNextButtonDisabled = false;
        this.isSelectAllDisabled = true;
        this.documentHistoryAvailabilityMap = new Map();
        this._destroy$ = new Subject_1.Subject();
        this._currentPage = 0;
        this._isReady = false;
    }
    DocumentManagerComponent_1 = DocumentManagerComponent;
    DocumentManagerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.entityInstanceId = dynamic_navigation_helper_1.getPropertyFromUrl(url_and_query_params_1.UrlAndQueryParams.rootEntityId, this.route);
        this.entityInstanceId && (this.entityInstanceId = +this.entityInstanceId);
        this.entityCategoryId = dynamic_navigation_helper_1.getPropertyFromUrl(url_and_query_params_1.UrlAndQueryParams.rootCategoryId, this.route);
        this.entityName$ = this.entityNameProviderService.getEntityName(this.entityCategoryId, this.entityInstanceId);
        if (this.entityInstanceId && this.entityCategoryId) {
            this.documentsData$ = this.documentManagerService.getDocuments(this.entityCategoryId, this.entityInstanceId)
                .pipe(operators_1.map(function (responseDocuments) {
                if (responseDocuments && responseDocuments['result']) {
                    _this.dataSource.data = responseDocuments['result'];
                    _this.allDocumentsCount = responseDocuments['allDocumentsCount'];
                    _this.documentsCount = responseDocuments['totalCount'];
                    _this.reloading = false;
                    _this.initDocumentHistoryInfo();
                    _this.calculateExtensionFlags();
                    _this.calculateSelectionFlags();
                    _this.calculatePagingProperties();
                    _this.isSelectAllDisabled = _this.reloading || _this.canSelectAllDocuments();
                    return responseDocuments;
                }
                _this.dataSource.data = [];
                _this.reloading = false;
                _this.isSelectAllDisabled = false;
                return [];
            }));
            this.users$ = this.documentManagerService.getUsers(this.entityCategoryId, this.entityInstanceId).publishReplay(1).refCount();
            this.folderNames$ = this.documentManagerService.getFolderNames(this.entityCategoryId).switchMap(function (folders) {
                return _this.documentsData$.map(function (documentsData) {
                    folders.forEach(function (value) {
                        value.count = documentsData['folders'][value.folder];
                    });
                    return folders;
                });
            }).publishReplay(1).refCount();
            this.folderNamesMap$ = this.folderNames$.pipe(operators_1.map(function (array) {
                var result = new Map();
                array.forEach(function (value) {
                    result.set(value.folder, { message: value.message, count: value.count });
                });
                return result;
            }), operators_1.publishReplay(1), operators_1.refCount());
            this.allDocumentsCount$ = this.folderNames$.map(function (documentsFolders) {
                var count = 0;
                documentsFolders.forEach(function (value) { return count += value.count; });
                return count;
            });
            this.documentManagerConfigProvider.loadDocumentManagerConfig()
                .pipe(operators_1.takeUntil(this._destroy$))
                .subscribe(function (documentConfig) {
                if (documentConfig.quickAccessButtons) {
                    _this._quickAccessButtons = _this.constructButtons(documentConfig);
                }
                _this._isReady = true;
            });
            combineLatest_1.combineLatest(this.documentsData$, this.entityName$, this.currentLanguageProvider.getCurrentLanguage())
                .takeUntil(this._destroy$).subscribe(function (_a) {
                var documentsData = _a[0], entityName = _a[1], currentLanguage = _a[2];
                _this.entityName = entityName;
                _this._currentLanguageId = currentLanguage.getId();
                _this.isDocumentDataInitialized = true;
            });
            this.hasSendNotificationPermission$ = this.hasSendNotificationPermission();
        }
    };
    DocumentManagerComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    DocumentManagerComponent.prototype.constructButtons = function (documentConfig) {
        if (documentConfig.quickAccessButtons) {
            var uniqueButtonsKey = new Set(documentConfig.quickAccessButtons);
            return Array.from(uniqueButtonsKey).slice(0, 3);
        }
    };
    DocumentManagerComponent.prototype.canSelectAllDocuments = function () {
        if (!this.dataSource.data || !this.dataSource.data.length) {
            return true;
        }
        if (this.selectionMode === selection_mode_model_1.SelectionMode.NOTIFICATION) {
            return false;
        }
        return this.dataSource.data.filter(function (document) { return document['isMergeable']; }).length === 0;
    };
    DocumentManagerComponent.prototype.onFolderSelect = function (selectedFolder) {
        this.selectedFolder = selectedFolder;
        this.onFilterChanged();
    };
    DocumentManagerComponent.prototype.onFilterChanged = function () {
        this._currentPage = 0;
        this.paginator && (this.paginator.pageIndex = 0);
        this.reloading = true;
        this.documentManagerService.reloadDocuments(new idm_de_core_frontend_1.PagingOptions(this._currentPage, this.pageLimit), this.createDocumentFilterCriteria(this.documentFilterCriteria));
    };
    DocumentManagerComponent.prototype.onResetFilter = function () {
        clearTimeout(this.documentFilterCriteria.searchTimeout);
        this.documentFilterCriteria.search = null;
        this.documentFilterCriteria.title = null;
        this.documentFilterCriteria.documentCategoryId = null;
        this.documentFilterCriteria.description = null;
        this.searchIsOpen = false;
        this._currentPage = 0;
        this.paginator.pageIndex = 0;
        this.reloading = true;
        this.documentManagerService.reloadDocuments(new idm_de_core_frontend_1.PagingOptions(this._currentPage, this.pageLimit), this.createDocumentFilterCriteria(this.documentFilterCriteria));
    };
    DocumentManagerComponent.prototype.onSearchCriteriaChanged = function (event) {
        var _this = this;
        this.documentFilterCriteria.search = event;
        clearTimeout(this.documentFilterCriteria.searchTimeout);
        this.documentFilterCriteria.searchTimeout = setTimeout(function () { return _this.onFilterChanged(); }, 300);
    };
    DocumentManagerComponent.prototype.onSearchCriteriaClosed = function () {
        this.documentFilterCriteria.search = null;
        this.searchIsOpen = false;
        this.onFilterChanged();
    };
    DocumentManagerComponent.prototype.openDocumentView = function (document) {
        // this.onDocumentClick.emit(document);
    };
    DocumentManagerComponent.prototype.onPreviewDocument = function (document) {
        var documentId = document['documentId'];
        var parentCategoryName = document['metadata']['parentMainCategory'];
        var categoryFieldName = document['metadata']['subEntityField'];
        var entityInstanceId = document['metadata']['parentInstanceId'];
        this.documentOperationsService.previewDocument(documentId, parentCategoryName, entityInstanceId, categoryFieldName)
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe();
    };
    DocumentManagerComponent.prototype.onDownloadDocument = function (document) {
        var documentId = document['documentId'];
        var parentCategoryName = document['metadata']['parentMainCategory'];
        var categoryFieldName = document['metadata']['subEntityField'];
        var entityInstanceId = document['metadata']['parentInstanceId'];
        this.documentOperationsService.downloadDocument(documentId, parentCategoryName, entityInstanceId, categoryFieldName)
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe();
    };
    DocumentManagerComponent.prototype.getDisplayedColumns = function () {
        var filteredColumns = this.displayedColumns;
        if (this.selectedFolder && this.selectedFolder !== this.allDocumentsLabel) {
            filteredColumns = filteredColumns
                .filter(function (column) { return column !== 'folder'; });
        }
        filteredColumns = this.hasCheckBoxes ?
            filteredColumns :
            filteredColumns.filter(function (column) { return column !== 'checkbox'; });
        return filteredColumns;
    };
    DocumentManagerComponent.prototype.onSelectAllChecked = function (event) {
        var _this = this;
        this.dataSource.data.forEach(function (document) {
            if (_this.selectionMode === selection_mode_model_1.SelectionMode.NOTIFICATION || document['isMergeable']) {
                _this.onDocumentSelect(document, event);
            }
        });
    };
    DocumentManagerComponent.prototype.onDocumentSelect = function (document, event) {
        if (event.checked) {
            this.unselectDocument(document);
            this.selectDocument(document);
        }
        else {
            this.unselectDocument(document);
        }
        this.isNextButtonDisabled = this.selectionMode == null ||
            (this.selectionMode === selection_mode_model_1.SelectionMode.MERGE && this.selectedDocuments.length < 2) ||
            (this.selectionMode === selection_mode_model_1.SelectionMode.NOTIFICATION && this.selectedDocuments.length === 0);
    };
    DocumentManagerComponent.prototype.openActionDialog = function () {
        if (this.selectionMode === selection_mode_model_1.SelectionMode.MERGE) {
            this.openMergeDialog();
        }
        else {
            this.openNotificationDialog();
        }
    };
    DocumentManagerComponent.prototype.openDocumentHistoryDialog = function (document) {
        var _this = this;
        var documentId = document['documentId'];
        var parentInstanceId = document['metadata']['parentInstanceId'];
        var parentMainCategory = document['metadata']['parentMainCategory'];
        var subEntityField = document['metadata']['subEntityField'];
        var documentSubCategory = document['metadata']['subEntityCompoundCategory'];
        Observable_1.Observable.combineLatest(this.kbService.getMetaFields(documentSubCategory), this.metaKnowledgeProviderService.getDocumentDefinitions(documentSubCategory), this.deService.loadEntityByInstanceId(parentMainCategory, parentInstanceId)).pipe(operators_1.map(function (_a) {
            var metaFields = _a[0], documentDefinitions = _a[1], parentMainEntity = _a[2];
            if (parentMainEntity) {
                var attachmentField = metaFields.find(function (field) { return field.getSystemName() === documentDefinitions.attachmentFieldId; });
                if (attachmentField) {
                    var subEntities = parentMainEntity.getProperty(subEntityField).value;
                    var currentSubEntity = subEntities.find(function (subEntity) {
                        return subEntity.getProperty(documentDefinitions.attachmentFieldId).value === documentId;
                    });
                    if (currentSubEntity) {
                        var config = document_history_dialog_component_1.DocumentHistoryDialogComponent.getConfig(currentSubEntity, documentDefinitions, _this._currentLanguageId, parentInstanceId, parentMainCategory, subEntityField);
                        _this.dialog.open(document_history_dialog_component_1.DocumentHistoryDialogComponent, config);
                    }
                }
                else {
                    console.warn(attachmentField + " field not found in " + documentSubCategory + " category");
                }
            }
        }), operators_1.takeUntil(this._destroy$)).subscribe();
    };
    DocumentManagerComponent.prototype.isDocumentHistoryAvailable = function (documentData) {
        var documentCategory = documentData['metadata']['subEntityCompoundCategory'];
        return this.documentHistoryAvailabilityMap.get(documentCategory);
    };
    DocumentManagerComponent.prototype.initDocumentHistoryInfo = function () {
        var _this = this;
        var documentSubCategoriesWithDuplicates = this.dataSource.data
            .map(function (documentData) { return documentData['metadata']['subEntityCompoundCategory']; });
        var documentSubCategories = Array.from(new Set(documentSubCategoriesWithDuplicates))
            .filter(function (subCategory) { return !_this.documentHistoryAvailabilityMap.has(subCategory); });
        if (documentSubCategories.length) {
            var historyAvailable$ = documentSubCategories.map(function (subCategory) {
                return document_history_service_1.DocumentHistoryService.getDocumentHistoryInfo(_this.injector, subCategory).pipe(operators_1.tap(function (documentHistoryInfo) {
                    return _this.documentHistoryAvailabilityMap.set(subCategory, documentHistoryInfo.isHistoryAvailable);
                }));
            });
            Observable_1.Observable.combineLatest.apply(Observable_1.Observable, historyAvailable$).pipe(operators_1.takeUntil(this._destroy$))
                .subscribe();
        }
    };
    DocumentManagerComponent.prototype.openMergeDialog = function () {
        var _this = this;
        var mergeData = this.constructMergeData();
        this.dialog.open(document_merge_component_1.DocumentMergeComponent, document_merge_component_1.DocumentMergeComponent.getConfig(mergeData))
            .afterClosed()
            .pipe(operators_1.take(1))
            .subscribe(function (dialogData) {
            _this.savedDialogData = dialogData;
            // case when dialog was closed by edit selection button
            if (dialogData != null) {
                var documentsIds_1 = _this.savedDialogData.documentsToMerge.map(function (document) { return document.documentId; });
                _this.selectedDocuments = _this.selectedDocuments.filter(function (document) { return documentsIds_1.includes(document.documentId); });
                _this.calculateSelectionFlags();
            }
            else {
                _this.resetSelectionData();
            }
        });
    };
    DocumentManagerComponent.prototype.openNotificationDialog = function () {
        var _this = this;
        var config = notification_dialog_component_1.NotificationDialogComponent.getConfig(this.entityInstanceId, this.entityCategoryId, this.selectedDocuments, this.savedDialogData);
        this.dialog.open(notification_dialog_component_1.NotificationDialogComponent, config)
            .afterClosed()
            .pipe(operators_1.take(1))
            .subscribe(function (dialogData) {
            _this.savedDialogData = dialogData;
            // case when dialog was closed by edit selection button
            if (dialogData != null) {
                var documentsIds_2 = _this.savedDialogData.notificationDto.documents.map(function (document) { return document.documentId; });
                _this.selectedDocuments = _this.selectedDocuments.filter(function (document) { return documentsIds_2.includes(document.documentId); });
                _this.calculateSelectionFlags();
            }
            else {
                _this.resetSelectionData();
            }
        });
    };
    DocumentManagerComponent.prototype.constructMergeData = function () {
        var _this = this;
        var dataForMerging = new data_for_merging_1.DataForMerging();
        dataForMerging.documentsToMerge = this.selectedDocuments.map(function (document) {
            var title = static_method_1.translateMultilingual(document['data']['title'], _this._currentLanguageId);
            return {
                documentId: document['documentId'],
                title: title,
                size: document['docInfo']['fileSize'],
                extension: static_method_1.extractExtensionFromFileName(document['docInfo']['fileName'])
            };
        });
        dataForMerging.mergedDocumentName = this.savedDialogData && this.savedDialogData.mergedDocumentName;
        dataForMerging.documentPaginationPosition = this.savedDialogData && this.savedDialogData.mergedDocumentName;
        dataForMerging.mergedDocumentFormat = this.savedDialogData && this.savedDialogData.mergedDocumentFormat;
        dataForMerging.categoryId = this.entityCategoryId;
        dataForMerging.entityId = this.entityInstanceId;
        dataForMerging.coverDisplayInfo = this.savedDialogData && this.savedDialogData.coverDisplayInfo;
        dataForMerging.coverTemplateData.layoutName = this.savedDialogData && this.savedDialogData.coverTemplateData.layoutName;
        dataForMerging.coverTemplateData.formProperties$ = this.formResolutionService.getEntityFormProperties(this.entityCategoryId, this.entityInstanceId);
        return dataForMerging;
    };
    DocumentManagerComponent.prototype.openExportDialog = function () {
        var config = documents_export_dialog_component_1.DocumentsExportDialogComponent.getConfig(this.entityInstanceId, this.entityName, this.entityCategoryId, this.allDocumentsCount);
        this.dialog.open(documents_export_dialog_component_1.DocumentsExportDialogComponent, config);
    };
    DocumentManagerComponent.prototype.resetSelectionData = function (selectionMode) {
        if (selectionMode === void 0) { selectionMode = null; }
        if (selectionMode !== this.selectionMode) {
            this.selectedDocuments = [];
            this.selectionMode = selectionMode;
            this.isNextButtonDisabled = this.selectionMode == null ||
                (this.selectionMode === selection_mode_model_1.SelectionMode.MERGE && this.selectedDocuments.length < 2) ||
                (this.selectionMode === selection_mode_model_1.SelectionMode.NOTIFICATION && this.selectedDocuments.length === 0);
            this.hasCheckBoxes = this.selectionMode !== null;
            this.calculateSelectionFlags();
            this.isSelectAllDisabled = this.reloading || this.canSelectAllDocuments();
        }
    };
    DocumentManagerComponent.prototype.createDocumentFilterCriteria = function (filterCriteria) {
        if (this.selectedFolder === this.allDocumentsLabel && !filterCriteria.title
            && !filterCriteria.documentCategoryId && !filterCriteria.description && !filterCriteria.search) {
            return null;
        }
        var folder = null;
        if (this.selectedFolder && this.selectedFolder !== this.allDocumentsLabel) {
            folder = this.selectedFolder;
        }
        return {
            search: filterCriteria.search,
            title: filterCriteria.title ? filterCriteria.title : null,
            documentCategoryId: filterCriteria.documentCategoryId,
            description: filterCriteria.description ? filterCriteria.description : null,
            attachmentIds: null,
            folder: folder
        };
    };
    DocumentManagerComponent.prototype.selectDocument = function (document) {
        this.selectedDocuments.push(document);
        this.calculateSelectionFlags();
    };
    DocumentManagerComponent.prototype.unselectDocument = function (document) {
        var index = this.selectedDocuments.findIndex(function (documentToMerge) { return documentToMerge.documentId === document.documentId; });
        if (index !== -1) {
            this.selectedDocuments.splice(index, 1);
            this.calculateSelectionFlags();
        }
    };
    DocumentManagerComponent.prototype.calculateSelectionFlags = function () {
        var _this = this;
        var selectableDocumentIds;
        if (this.selectionMode === selection_mode_model_1.SelectionMode.MERGE) {
            selectableDocumentIds = this.dataSource.data.filter(function (document) { return document['isMergeable']; }).map(function (value) { return value['documentId']; });
        }
        else {
            selectableDocumentIds = this.dataSource.data.map(function (document) { return document['documentId']; });
        }
        var selectedDocumentIds = this.selectedDocuments.map(function (selectedDocument) { return selectedDocument.documentId; });
        this.isEverySelected = selectableDocumentIds.length === 0 ? false : selectableDocumentIds.every(function (documentId) { return selectedDocumentIds.includes(documentId); });
        this.isSomeSelected = selectableDocumentIds.some(function (documentId) { return selectedDocumentIds.includes(documentId); });
        this.isItemSelected = {};
        selectedDocumentIds.forEach(function (value) { return _this.isItemSelected[value] = true; });
    };
    DocumentManagerComponent.prototype.calculateExtensionFlags = function () {
        this.dataSource.data.forEach(function (item) {
            var fileName = item['docInfo']['fileName'];
            var extension = static_method_1.extractExtensionFromFileName(fileName);
            item['isMergeable'] = static_method_1.isMergeableFormat(extension);
        });
    };
    DocumentManagerComponent.prototype.calculatePagingProperties = function () {
        this.totalItemsCount = this.documentsCount;
        this.pageTotalCount = Math.ceil(this.totalItemsCount / this.pageLimit);
    };
    DocumentManagerComponent.prototype.hasSendNotificationPermission = function () {
        var _this = this;
        return this.sessionDataProvider.getCurrentUserData().pipe(operators_1.switchMap(function (currentUserData) {
            return _this.authorizationService.getPermissionAccessValue(currentUserData.userId, DocumentManagerComponent_1.SEND_NOTIFICATION_ACCESS_PERMISSION_KEY);
        }), operators_1.map(function (permissionValue) {
            return permissionValue.access === idm_authorization_client_js_1.Access.FULL;
        }), operators_1.take(1));
    };
    Object.defineProperty(DocumentManagerComponent.prototype, "currentPage", {
        get: function () {
            return this._currentPage;
        },
        set: function (currentPage) {
            if (currentPage.pageSize === 0) {
                currentPage.pageSize = this.pageLimit;
            }
            this.pageLimit = currentPage.pageSize;
            this._currentPage = currentPage.pageIndex;
            this.documentManagerService.reloadDocuments(new idm_de_core_frontend_1.PagingOptions(this._currentPage, this.pageLimit), this.createDocumentFilterCriteria(this.documentFilterCriteria));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentManagerComponent.prototype, "quickAccessButtons", {
        get: function () {
            return this._quickAccessButtons;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentManagerComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    var DocumentManagerComponent_1;
    DocumentManagerComponent.SEND_NOTIFICATION_ACCESS_PERMISSION_KEY = 'a30bf439-b011-4217-be16-c32a1c13c69a';
    __decorate([
        core_1.ViewChild('drawer'),
        __metadata("design:type", material_1.MatDrawer)
    ], DocumentManagerComponent.prototype, "drawer", void 0);
    __decorate([
        core_1.ViewChild('paginator'),
        __metadata("design:type", core_1.ElementRef)
    ], DocumentManagerComponent.prototype, "paginator", void 0);
    DocumentManagerComponent = DocumentManagerComponent_1 = __decorate([
        core_1.Component({
            selector: 'ejustice-document-manager',
            template: require('./document-manager.component.html'),
            styles: [require('./document-manager.component.css')],
            providers: [document_manager_service_1.DocumentManagerService]
        }),
        __metadata("design:paramtypes", [idm_document_service_client_js_1.DocumentService,
            document_operations_service_1.DocumentOperationsService,
            http_1.HttpClient,
            idm_de_service_client_js_1.DeService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            document_manager_service_1.DocumentManagerService,
            router_1.ActivatedRoute,
            material_1.MatDialog,
            entity_name_provider_service_1.EntityNameProviderService,
            form_resolution_service_1.FormResolutionService,
            idm_session_data_provider_api_js_1.SessionDataProvider,
            idm_authorization_client_js_1.AuthorizationService,
            idm_kb_service_client_js_1.KbService,
            meta_knowledge_provider_service_1.MetaKnowledgeProviderService,
            document_manager_config_provider_1.DocumentManagerConfigProvider,
            core_1.Injector])
    ], DocumentManagerComponent);
    return DocumentManagerComponent;
}());
exports.DocumentManagerComponent = DocumentManagerComponent;
//# sourceMappingURL=document-manager.component.js.map